/* Données produits. Dans Shopify, elles sont remplacées par les objets product / collection. */

window.PRODUCTS = [
  {
    handle: "kiyohako-one",
    ja: "キヨハコ・ワン",
    title: "Kiyohako One",
    subtitle: "Litière autonettoyante",
    /* Titre et description envoyés à Google Shopping (champ « référencement » de Shopify, 70 et 320 caractères au plus) */
    googleTitle: "Litière autonettoyante Kiyohako One – bac ouvert, Wi-Fi, tiroir 11 L",
    googleDesc: "Litière autonettoyante à bac ouvert : après chaque passage, le bac pivote et tamise la litière, et les déchets tombent dans un tiroir de 11 L. Nettoyage différé de 1 à 60 min, double capteur de sécurité, suivi du poids du chat dans l'appli (Wi-Fi 2,4 GHz). Chats dès 1,5 kg, litière agglomérante. 55 × 51 × 53,6 cm.",
    type: "litter-box",
    price: 39900,
    installments: 3,
    color: "Gris clair",
    sku: "KH-ONE",
    delivery: [3, 7], // jours ouvrés après la commande (fournisseur : DHL depuis l’Allemagne, « livraison en 7 jours », garantie en 7 j ouvrés)
    merchantImages: ["assets/images/one-front.webp", "assets/images/life-living.webp", "assets/images/life-bath.webp", "assets/images/life-cat.webp", "assets/images/one-drawer.webp", "assets/images/one-controls.webp"], // images sans texte, pour Google
    category: "Animals & Pet Supplies > Pet Supplies > Cat Supplies > Cat Litter Boxes",
    rating: null, // note moyenne réelle (ex. 4.6), fournie par l’application d’avis
    reviews: 0, // nombre d’avis vérifiés
    fit: "Pour un ou plusieurs chats",
    highlights: ["Nettoyage après chaque passage", "Pesée de votre chat à chaque visite", "Double capteur de sécurité", "Tiroir de 11 L"],
    ecoFee: null, // montant de l'éco-participation DEEE en centimes, à renseigner après inscription à l'éco-organisme
    shipping: "Expédiée sous 2 jours ouvrés",
    video: { src: "assets/video/ad-30s.mp4", poster: "assets/video/kiyohako-one-poster.webp", alt: "Kiyohako One, le film de 30 secondes" },
    images: [
      { src: "assets/images/pdp-hero.webp", alt: "Kiyohako One, propre sans y penser" },
      { src: "assets/images/pdp-features.webp", alt: "Autonettoyante, double capteur, appli ou boutons, tiroir de 11 L" },
      { src: "assets/images/pdp-scale.webp", alt: "Kiyohako One à côté d’une personne : 51 × 53,6 × 55 cm" },
      { src: "assets/images/pdp-hall.webp", alt: "Un chat dans Kiyohako One, dans une entrée lumineuse" },
      { src: "assets/images/pdp-leap.webp", alt: "Un chat saute hors de Kiyohako One dans un intérieur sombre" },
      { src: "assets/images/life-bath.webp", alt: "Kiyohako One dans une salle de bain, un chat à côté" }
    ],
    cardImages: [
      { src: "assets/images/one-front.webp", alt: "Kiyohako One, vue de trois quarts" },
      { src: "assets/images/life-living.webp", alt: "Kiyohako One dans le coin d’un salon calme" }
    ],
    /* Bénéfice d'abord, preuve ensuite ; espace insécable avant « : » (typographie française) */
    benefits: [
      "Fini la pelle : il se nettoie seul après chaque passage",
      "Sans toucher aux déchets : tiroir de 11 L et sacs fournis",
      "Sûr pour votre chat : deux capteurs veillent pendant tout le cycle",
      "Ses habitudes à l’œil : poids et passages suivis dans l’appli",
      "Rassurant, même pour un chaton : bac ouvert, sans tunnel, dès 1,5 kg"
    ],
    description:
      "Kiyohako One est une litière autonettoyante à bac ouvert. Après chaque passage, le bac pivote et tamise la litière : les agglomérats tombent dans un tiroir de 11 L. Deux capteurs veillent sur votre chat pendant le cycle, et vous suivez tout depuis l’application.",
    specs: [
      ["Dimensions", "55 × 51 × 53,6 cm"],
      ["Poids", "12 kg"],
      ["Tiroir", "11 L"],
      ["Connexion", "Wi-Fi 2,4 GHz"],
      ["Commandes", "3 boutons : Wi-Fi, nettoyage, vidage complet"],
      ["Chat", "À partir de 1,5 kg"],
      ["Alimentation", "DC 12 V / 2 A"]
    ],
    inBox: ["Kiyohako One", "Tiroir à déchets", "Sacs pour tiroir", "Adaptateur secteur", "Notice en français"],
    dims: { width: "51 cm", depth: "55 cm", height: "53,6 cm" },
    dimSpecs: [
      ["Largeur", "51 cm"],
      ["Profondeur", "55 cm"],
      ["Hauteur", "53,6 cm"],
      ["Tiroir", "11 L"],
      ["Poids", "12 kg"],
      ["Alimentation", "DC 12 V / 2 A"]
    ],
    compat: [
      ["Litière", "Agglomérante, minérale ou végétale (tofu)"],
      ["Chat", "À partir de 1,5 kg, chatons compris"],
      ["Connexion", "Wi-Fi 2,4 GHz"],
      ["Commande", "Application ou 3 boutons"],
      ["Modes", "Automatique ou manuel"],
      ["Matériaux", "ABS, PP, POM"]
    ],
    safety: [
      ["Fabricant", "Kiyohako, 21 bis route de Montfort, 78990 Élancourt, France, bonjour@kiyohako.com"],
      ["Pays de fabrication", "Chine"],
      ["Référence", "KH-ONE"],
      ["Conformité", "CE, RoHS"],
      ["Sécurité", "Double capteur de présence, nettoyage différé"],
      ["Consignes", "Usage intérieur, au sec, sur un sol plat. Chat de 1,5 kg minimum. Surveillez les premières utilisations. Voir la notice."]
    ],
    addons: ["kiyohako-duo", "tapis-litiere"] // garantie-5-ans retirée pour l’instant ; le tapis n’apparaît qu’une fois publié dans Shopify
  },
  {
    handle: "kiyohako-duo",
    ja: "キヨハコ・デュオ",
    title: "Kiyohako Duo",
    subtitle: "Distributeur de croquettes et fontaine",
    googleTitle: "Distributeur de croquettes et fontaine Kiyohako Duo – 6 L et 2,5 L",
    googleDesc: "Distributeur de croquettes et fontaine à eau réunis. Repas programmés depuis l'application : les croquettes tombent à l'heure dans un bol en acier inoxydable, la fontaine fait circuler l'eau, et une alerte prévient quand il faut remplir. Réservoir de 6 L, fontaine de 2,5 L, commande par appli ou boutons. CE et RoHS.",
    type: "feeder",
    price: 12900, // prix de vente à valider
    installments: 3,
    color: "Blanc",
    sku: "KH-DUO",
    // Coloris : le premier reprend images, cardImages et merchantImages du produit ; les autres les remplacent.
    colors: [
      { name: "Blanc", swatch: "#f1f0eb" },
      {
        name: "Noir",
        swatch: "#1f1f1e",
        sku: "KH-DUO-NOIR",
        merchantImages: ["assets/images/duo-noir-studio.webp", "assets/images/duo-noir-kitchen.webp", "assets/images/duo-noir-drink.webp", "assets/images/duo-noir-refill.webp"],
        images: [
          { src: "assets/images/duo-noir-studio.webp", alt: "Kiyohako Duo noir, le distributeur de croquettes et la fontaine à eau" },
          { src: "assets/images/duo-noir-kitchen.webp", alt: "Un chat mange dans le bol de Kiyohako Duo noir, dans une cuisine claire" },
          { src: "assets/images/duo-noir-drink.webp", alt: "Un chat gris boit à la fontaine de Kiyohako Duo noir" },
          { src: "assets/images/duo-noir-refill.webp", alt: "On verse des croquettes dans le réservoir de 6 L de Kiyohako Duo noir" }
        ],
        cardImages: [
          { src: "assets/images/duo-noir-studio.webp", alt: "Kiyohako Duo noir, distributeur de croquettes et fontaine" },
          { src: "assets/images/duo-noir-kitchen.webp", alt: "Un chat mange dans le bol de Kiyohako Duo noir" }
        ]
      }
    ],
    delivery: [4, 7], // fournisseur : « livraison en 7 jours », garantie en 7 j ouvrés
    merchantImages: ["assets/images/duo-studio.webp", "assets/images/duo-kitchen.webp", "assets/images/duo-drink.webp", "assets/images/duo-refill.webp", "assets/images/duo-hero.webp"],
    category: "Animals & Pet Supplies > Pet Supplies > Pet Bowls, Feeders & Waterers",
    rating: null, // note moyenne réelle (ex. 4.6), fournie par l’application d’avis
    reviews: 0, // nombre d’avis vérifiés
    badge: "Nouveau",
    ecoFee: null, // éco-participation DEEE en centimes, à renseigner
    shipping: "Expédiée sous 2 jours ouvrés",
    video: { src: "assets/video/duo-ad-30s.mp4", poster: "assets/video/duo-ad-poster.webp", alt: "Kiyohako Duo, le film de 30 secondes" },
    fit: "Repas et eau, au même endroit",
    offer: {
      heading: "Ajoutez Kiyohako Duo",
      desc: "Croquettes et fontaine.",
      thumb: true,
      sheet: {
        img: "assets/images/duo-kitchen-roux.webp",
        title: "Kiyohako Duo",
        list: ["Des repas à heure fixe, même quand vous n’êtes pas là", "Réservoir de croquettes de 6 L", "Fontaine à eau de 2,5 L", "Programmation et alertes depuis l’application", "Bols en acier inoxydable, faciles à laver"]
      }
    },
    highlights: ["Réservoir de croquettes 6 L", "Fontaine à eau 2,5 L", "Repas programmés depuis l’appli", "Alerte quand il faut remplir"],
    images: [
      { src: "assets/images/duo-hero.webp", alt: "Kiyohako Duo, le distributeur de croquettes et la fontaine à eau" },
      { src: "assets/images/duo-kitchen.webp", alt: "Un chat mange dans le bol de Kiyohako Duo, dans une cuisine claire" },
      { src: "assets/images/duo-drink.webp", alt: "Un chat gris boit à la fontaine de Kiyohako Duo" },
      { src: "assets/images/duo-refill.webp", alt: "On verse des croquettes dans le réservoir de 6 L" }
    ],
    cardImages: [
      { src: "assets/images/duo-studio.webp", alt: "Kiyohako Duo, distributeur de croquettes et fontaine" },
      { src: "assets/images/duo-kitchen.webp", alt: "Un chat mange dans le bol de Kiyohako Duo" }
    ],
    benefits: [
      "Des repas à heure fixe, même quand vous n’êtes pas là",
      "Réservoir de croquettes de 6 L et fontaine de 2,5 L",
      "Programmation et suivi depuis l’application",
      "Notification quand les croquettes ou l’eau viennent à manquer",
      "Bols en acier inoxydable, faciles à laver",
      "Certifié CE et RoHS"
    ],
    description:
      "Kiyohako Duo réunit un distributeur de croquettes et une fontaine à eau. Programmez les repas depuis l’application : les croquettes tombent à l’heure dans un bol en acier inoxydable, et la fontaine fait circuler l’eau. Vous êtes prévenu quand il faut remplir.",
    specs: [
      ["Croquettes", "Réservoir de 6 L"],
      ["Eau", "Fontaine de 2,5 L"],
      ["Poids", "2,3 kg"],
      ["Matériaux", "ABS, acier inoxydable"],
      ["Commande", "Application ou boutons"],
      ["Conformité", "CE, RoHS"],
      ["Pays de fabrication", "Chine"],
      ["Fabricant", "Kiyohako, 21 bis route de Montfort, 78990 Élancourt, France, bonjour@kiyohako.com"]
    ],
    inBox: ["Distributeur de croquettes", "Fontaine à eau", "Bol en acier inoxydable", "Câble d’alimentation", "Notice en français"],
    faq: [
      ["Pour quels animaux ?", "Pour les chats et les petits chiens nourris aux croquettes. Le distributeur est prévu pour des croquettes sèches : la pâtée et la nourriture humide ne conviennent pas."],
      ["Comment programmer les repas ?", "Depuis l’application, choisissez l’heure de chaque repas et le nombre de portions. Vous pouvez aussi servir un repas immédiatement."],
      ["Que se passe-t-il quand le réservoir est vide ?", "Vous recevez une notification sur votre téléphone quand les croquettes ou l’eau viennent à manquer."],
      ["Comment le nettoyer ?", "Le bol et le plateau de la fontaine, en acier inoxydable, se retirent et se lavent à l’eau savonneuse. Le réservoir se démonte lui aussi."],
      ["Où est-il fabriqué ?", "Kiyohako Duo est fabriqué en Chine par un partenaire industriel et conforme aux normes européennes CE et RoHS."],
      ["Et s’il ne me convient pas ?", "Vous disposez de 14 jours après la réception pour vous rétracter, sans avoir à vous justifier. Nous vous remboursons intégralement, livraison comprise. Les frais de retour sont à votre charge, sauf si le produit est défectueux, endommagé ou non conforme."],
      ["Quelle garantie ?", "Kiyohako Duo bénéficie de la garantie légale de conformité de 2 ans."]
    ]
  },
  /* Accessoires (vendeurs AliExpress, stock en France) : brouillons dans Shopify tant que les vendeurs n’ont pas confirmé
     stock, emballage neutre et coloris. Un produit absent de la boutique Shopify n’apparaît nulle part sur le site. */
  {
    handle: "tapis-litiere",
    ja: "トイレマット",
    title: "Tapis de litière",
    subtitle: "Double couche en nid d’abeille",
    type: "accessory",
    price: 2900,
    color: "Gris",
    sku: "KH-TAPIS",
    delivery: [3, 7],
    merchantImages: ["assets/images/tapis-litiere-studio.webp", "assets/images/tapis-salon.webp"],
    category: "Animals & Pet Supplies > Pet Supplies > Cat Supplies > Cat Litter Box Mats",
    rating: null,
    reviews: 0,
    shipping: "Expédié sous 2 jours ouvrés",
    fit: "Sous Kiyohako One ou un autre bac",
    offer: {
      heading: "Votre tapis de litière offert",
      desc: "Retient les grains à la sortie du bac.",
      thumb: true,
      sheet: {
        img: "assets/images/tapis-salon.webp",
        title: "Tapis de litière",
        list: ["Retient les grains collés aux pattes", "Se vide en soulevant le dessus", "Fond imperméable qui protège le sol", "60 × 90 cm : Kiyohako One tient dessus"]
      }
    },
    highlights: ["60 × 90 cm", "Double couche en nid d’abeille", "Fond imperméable", "Se vide en un geste"],
    images: [
      { src: "assets/images/tapis-litiere-studio.webp", alt: "Le tapis de litière gris à double couche en nid d’abeille" },
      { src: "assets/images/tapis-salon.webp", alt: "Kiyohako One posée sur le tapis de litière, un chat en sort" }
    ],
    cardImages: [
      { src: "assets/images/tapis-litiere-studio.webp", alt: "Tapis de litière gris à double couche" },
      { src: "assets/images/tapis-salon.webp", alt: "Kiyohako One sur le tapis de litière" }
    ],
    benefits: [
      "Retient les grains de litière collés aux pattes, à la sortie du bac",
      "Les grains passent à travers les alvéoles et restent entre les deux couches",
      "Pour le vider, on soulève le dessus et on reverse les grains",
      "Fond imperméable qui protège le sol",
      "60 × 90 cm : Kiyohako One tient dessus, avec 35 cm devant"
    ],
    description:
      "Le tapis de litière se place sous le bac, côté sortie. Les grains collés aux pattes de votre chat passent à travers les alvéoles du dessus et restent piégés entre les deux couches. Pour le vider, on soulève la couche du dessus et on reverse les grains.",
    specs: [
      ["Dimensions", "60 × 90 cm"],
      ["Matière", "EVA"],
      ["Structure", "Deux couches : dessus en nid d’abeille, dessous imperméable"],
      ["Entretien", "Se rince à l’eau claire"],
      ["Pays de fabrication", "Chine"],
      ["Fabricant", "Kiyohako, 21 bis route de Montfort, 78990 Élancourt, France, bonjour@kiyohako.com"]
    ],
    inBox: ["Tapis de litière 60 × 90 cm"],
    faq: [
      ["Quelle taille ?", "60 × 90 cm. Kiyohako One se pose dessus et il reste environ 35 cm devant le bac, là où votre chat sort."],
      ["Comment le vider ?", "Les grains passent dans les alvéoles et restent entre les deux couches. Soulevez la couche du dessus et reversez les grains dans le bac ou à la poubelle."],
      ["Comment le nettoyer ?", "Videz-le, rincez-le à l’eau claire et laissez-le sécher à plat."],
      ["Et s’il ne me convient pas ?", "Vous disposez de 14 jours après la réception pour vous rétracter, sans avoir à vous justifier. Nous vous remboursons intégralement, livraison comprise. Les frais de retour sont à votre charge, sauf si le produit est défectueux, endommagé ou non conforme."],
      ["Quelle garantie ?", "Le tapis de litière bénéficie de la garantie légale de conformité de 2 ans."]
    ]
  },
  {
    handle: "lit-petale",
    ja: "花びらのベッド",
    title: "Lit Pétale",
    subtitle: "Coussin crème, structure en bouleau",
    type: "accessory",
    price: 12900,
    installments: 3,
    color: "Crème",
    sku: "KH-LIT",
    delivery: [3, 7],
    merchantImages: ["assets/images/lit-petale-studio.webp", "assets/images/lit-petale-salon.webp"],
    category: "Animals & Pet Supplies > Pet Supplies > Cat Supplies > Cat Beds",
    rating: null,
    reviews: 0,
    shipping: "Expédié sous 2 jours ouvrés",
    fit: "Pour se rouler en boule",
    highlights: ["55 × 55 × 32 cm", "Coussin épais en pétales", "Structure en bouleau", "Surélevé du sol"],
    images: [
      { src: "assets/images/lit-petale-studio.webp", alt: "Le Lit Pétale, coussin crème sur une structure en bouleau" },
      { src: "assets/images/lit-petale-salon.webp", alt: "Un chat dort dans le Lit Pétale, dans un salon lumineux" }
    ],
    cardImages: [
      { src: "assets/images/lit-petale-studio.webp", alt: "Lit Pétale, coussin crème et bouleau" },
      { src: "assets/images/lit-petale-salon.webp", alt: "Un chat dort dans le Lit Pétale" }
    ],
    benefits: [
      "Un coussin épais aux pétales arrondis, où votre chat se roule en boule",
      "Surélevé du sol par une structure basse en bouleau",
      "55 × 55 cm de couchage",
      "Une couleur crème et des lignes douces, faites pour le salon",
      "Se monte en quelques minutes"
    ],
    description:
      "Le Lit Pétale associe un coussin crème aux pétales arrondis et une structure basse en bouleau. Votre chat s’y installe en boule, à l’écart du sol, et le lit trouve sa place dans le salon comme un meuble.",
    specs: [
      ["Dimensions", "55 × 55 × 32 cm"],
      ["Poids", "2,6 kg"],
      ["Structure", "Bouleau"],
      ["Coussin", "Coton"],
      ["Montage", "Structure à assembler, visserie fournie"],
      ["Pays de fabrication", "Chine"],
      ["Fabricant", "Kiyohako, 21 bis route de Montfort, 78990 Élancourt, France, bonjour@kiyohako.com"]
    ],
    inBox: ["Coussin", "Structure en bouleau", "Visserie"],
    addons: ["tour-cylindre"],
    faq: [
      ["Pour quelle taille de chat ?", "Le couchage mesure 55 × 55 cm : il convient à la plupart des chats adultes, qui s’y installent en boule."],
      ["Faut-il le monter ?", "Oui : la structure en bouleau s’assemble en quelques minutes, la visserie est fournie."],
      ["Et s’il ne me convient pas ?", "Vous disposez de 14 jours après la réception pour vous rétracter, sans avoir à vous justifier. Nous vous remboursons intégralement, livraison comprise. Les frais de retour sont à votre charge, sauf si le produit est défectueux, endommagé ou non conforme."],
      ["Quelle garantie ?", "Le Lit Pétale bénéficie de la garantie légale de conformité de 2 ans."]
    ]
  },
  {
    handle: "tour-cylindre",
    ja: "キャットタワー",
    title: "Tour Cylindre",
    subtitle: "Arbre à chat en sisal, 113 cm",
    type: "accessory",
    price: 16900,
    installments: 3,
    color: "Crème",
    sku: "KH-TOUR",
    delivery: [3, 7],
    merchantImages: ["assets/images/tour-studio.webp", "assets/images/tour-salon.webp"],
    category: "Animals & Pet Supplies > Pet Supplies > Cat Supplies > Cat Furniture",
    rating: null,
    reviews: 0,
    shipping: "Expédiée sous 2 jours ouvrés",
    fit: "Grimper, se cacher, griffer",
    highlights: ["113 cm de haut", "Ø 39 cm au sol", "3 niveaux et un lit au sommet", "Sisal naturel"],
    images: [
      { src: "assets/images/tour-studio.webp", alt: "La Tour Cylindre, arbre à chat crème en sisal" },
      { src: "assets/images/tour-salon.webp", alt: "Deux chats dans la Tour Cylindre, près d’une fenêtre" }
    ],
    cardImages: [
      { src: "assets/images/tour-studio.webp", alt: "Tour Cylindre, arbre à chat en sisal" },
      { src: "assets/images/tour-salon.webp", alt: "Un chat dans la Tour Cylindre" }
    ],
    benefits: [
      "Trois niveaux à l’intérieur, avec une ouverture à chaque niveau",
      "Un lit rond rembourré au sommet, pour surveiller la pièce",
      "Deux panneaux de sisal pour griffer, plutôt que le canapé",
      "113 cm de haut pour 39 cm de diamètre au sol",
      "Chaque niveau supporte 15 kg"
    ],
    description:
      "La Tour Cylindre est un arbre à chat compact : un cylindre crème de 113 cm, trois niveaux à l’intérieur et un lit rembourré au sommet. Votre chat grimpe, se cache, griffe le sisal et dort en hauteur, sur seulement 39 cm de diamètre au sol.",
    specs: [
      ["Hauteur", "113 cm"],
      ["Diamètre", "39 cm à la base, 43 cm au sommet"],
      ["Ouvertures", "Ø 19 cm"],
      ["Niveaux", "3 niveaux intérieurs et un lit au sommet"],
      ["Griffoirs", "2 panneaux de sisal de 28 × 57 cm"],
      ["Charge", "15 kg par niveau"],
      ["Pays de fabrication", "Chine"],
      ["Fabricant", "Kiyohako, 21 bis route de Montfort, 78990 Élancourt, France, bonjour@kiyohako.com"]
    ],
    inBox: ["Éléments de la tour", "Lit rond rembourré", "Visserie et notice de montage"],
    addons: ["lit-petale"],
    faq: [
      ["Faut-il la monter ?", "Oui, le montage est simple et se fait en suivant la notice."],
      ["Pour combien de chats ?", "Chaque niveau supporte 15 kg : la tour convient aussi aux foyers de plusieurs chats."],
      ["Et si elle ne me convient pas ?", "Vous disposez de 14 jours après la réception pour vous rétracter, sans avoir à vous justifier. Nous vous remboursons intégralement, livraison comprise. Les frais de retour sont à votre charge, sauf si le produit est défectueux, endommagé ou non conforme."],
      ["Quelle garantie ?", "La Tour Cylindre bénéficie de la garantie légale de conformité de 2 ans."]
    ]
  },
  {
    /* Retiré de la vente le 21 octobre 2026 (brouillon dans Shopify) : invisible sur la boutique tant qu'il n'est pas republié */
    handle: "set-mural",
    ja: "キャットウォール",
    title: "Set mural",
    subtitle: "6 éléments en bois clair",
    type: "accessory",
    price: 17900,
    installments: 3,
    color: "Bois clair",
    sku: "KH-MURAL",
    delivery: [3, 7],
    merchantImages: ["assets/images/set-mural-studio.webp", "assets/images/set-mural-salon.webp"],
    category: "Animals & Pet Supplies > Pet Supplies > Cat Supplies > Cat Furniture",
    rating: null,
    reviews: 0,
    shipping: "Expédié sous 2 jours ouvrés",
    fit: "Un parcours en hauteur",
    highlights: ["6 éléments à fixer au mur", "Bois clair", "Niche, marches et plateforme", "2 gamelles inox incluses"],
    images: [
      { src: "assets/images/set-mural-studio.webp", alt: "Le Set mural en bois clair fixé sur un mur blanc" },
      { src: "assets/images/set-mural-salon.webp", alt: "Un chat saute d’une étagère du Set mural à l’autre, au-dessus d’un canapé" }
    ],
    cardImages: [
      { src: "assets/images/set-mural-studio.webp", alt: "Set mural en bois clair" },
      { src: "assets/images/set-mural-salon.webp", alt: "Un chat sur le Set mural" }
    ],
    benefits: [
      "Un parcours en hauteur qui libère le sol",
      "Une niche, une colonne à trois marches, des marches rondes, une plateforme et un coin repas",
      "Deux gamelles en acier inoxydable incluses",
      "Bois clair, assorti à un intérieur lumineux",
      "Chaque élément se fixe séparément : vous composez le parcours"
    ],
    description:
      "Le Set mural transforme un mur en terrain de jeu : une niche, une colonne à trois marches, des marches rondes, une plateforme et un coin repas avec deux gamelles en inox, en bois clair. Vous composez le parcours selon la place, du sol jusqu’en hauteur.",
    specs: [
      ["Éléments", "Niche, colonne à 3 marches, 2 marches rondes, plateforme, coin repas"],
      ["Niche", "29 × 30 × 32 cm"],
      ["Colonne", "95 cm de haut"],
      ["Plateforme", "44 × 33 cm"],
      ["Coin repas", "44 × 30 cm, 2 gamelles en inox"],
      ["Marches rondes", "2, Ø 16,5 cm"],
      ["Matière", "Bois"],
      ["Fixation", "Murale, visserie fournie"],
      ["Pays de fabrication", "Chine"],
      ["Fabricant", "Kiyohako, 21 bis route de Montfort, 78990 Élancourt, France, bonjour@kiyohako.com"]
    ],
    inBox: ["6 éléments en bois", "2 gamelles en acier inoxydable", "Visserie et notice"],
    faq: [
      ["Sur quel mur le fixer ?", "Sur un mur plein (béton, brique), avec la visserie fournie. Sur une plaque de plâtre, utilisez des chevilles adaptées."],
      ["Peut-on choisir la disposition ?", "Oui : chaque élément se fixe séparément, vous composez le parcours selon votre mur."],
      ["Et s’il ne me convient pas ?", "Vous disposez de 14 jours après la réception pour vous rétracter, sans avoir à vous justifier. Nous vous remboursons intégralement, livraison comprise. Les frais de retour sont à votre charge, sauf si le produit est défectueux, endommagé ou non conforme."],
      ["Quelle garantie ?", "Le Set mural bénéficie de la garantie légale de conformité de 2 ans."]
    ]
  },
  {
    handle: "garantie-5-ans",
    ja: "延長保証",
    title: "Garantie étendue 5 ans",
    subtitle: "En plus de la garantie légale de 2 ans",
    type: "service",
    price: 5900,
    offer: {
      heading: "Protégez votre Kiyohako One",
      title: "Garantie 5 ans",
      desc: "En plus de la garantie légale de 2 ans.",
      checks: ["Pièces", "Main d’œuvre", "Transport"],
      sheet: {
        img: "assets/images/life-living.webp",
        title: "Garantie étendue 5 ans",
        list: ["Pièces prises en charge pendant 5 ans", "Main-d’œuvre incluse", "Transport pris en charge", "S’ajoute à la garantie légale de conformité de 2 ans"]
      }
    },
    images: [{ src: "assets/brand/favicon.svg", alt: "Garantie Litière" }],
    description: "Pièces, main-d’œuvre et transport pris en charge pendant cinq ans.",
    specs: [],
    inBox: []
  }
];

/* Packs : remise appliquée quand les deux produits sont dans le panier (remise automatique dans Shopify).
   Avec « code » : offre de bienvenue, appliquée seulement au paiement avec ce code, sur une première commande. */
window.BUNDLES = [
  { main: "kiyohako-one", item: "kiyohako-duo", discount: 2000, label: "Remise pack One + Duo" },
  { main: "kiyohako-one", item: "tapis-litiere", discount: 2900, code: "TAPISOFFERT", label: "Tapis offert" } // depuis le 23 octobre 2026, à la place de la remise automatique de 10 € (désactivée) ; Shopify n'applique qu'une offre par Kiyohako One, le tapis offert passe avant le pack Duo
];

window.FAQ = [
  ["Mon chat va-t-il l’adopter ?", "La plupart des chats s’y habituent en quelques jours : le bac reste ouvert, sans porte ni tunnel. Placez Kiyohako One à côté de l’ancien bac avec la même litière, puis retirez l’ancien bac quand votre chat l’utilise seul. Les premiers jours, vous pouvez lancer le nettoyage vous-même."],
  ["Est-ce sans danger pour mon chat ?", "Kiyohako One est conçu pour sa sécurité : le nettoyage ne démarre qu’après un délai que vous réglez, de 1 à 60 minutes après la sortie de votre chat, et deux capteurs surveillent sa présence pendant tout le cycle. Il convient aux chats à partir de 1,5 kg. Surveillez les premières utilisations et suivez la notice."],
  ["Quelle litière utiliser ?", "Une litière agglomérante, minérale ou végétale (type tofu). Les granulés de bois et les cristaux non agglomérants ne conviennent pas au tamisage."],
  ["Comment gérer les odeurs ?", "Les agglomérats tombent dans un tiroir de 11 L équipé de sacs à lien. Il suffit de sortir le sac quand le tiroir est plein."],
  ["Pour combien de chats ?", "Le bac est remis à niveau après chaque passage, ce qui convient aussi aux foyers de plusieurs chats ; le tiroir se vide simplement plus souvent."],
  ["Faut-il une application ?", "Non. Trois boutons suffisent : connexion Wi-Fi, nettoyage en un clic et vidage complet du bac. L’application (Wi-Fi 2,4 GHz) ajoute le suivi : poids de votre chat, durée et nombre de passages par jour et par mois, délai de nettoyage, mode automatique ou manuel et luminosité du rétroéclairage."],
  ["Où est-elle fabriquée ?", "Kiyohako One est fabriquée en Chine par un partenaire industriel et conforme aux normes européennes CE et RoHS. Notre nom et notre design s’inspirent du Japon."],
  ["Comment se passe la livraison ?", "La livraison est offerte en France métropolitaine, à domicile. Votre commande est expédiée sous 2 jours ouvrés depuis notre entrepôt en Europe et livrée en 3 à 7 jours ouvrés. Vous recevez un numéro de suivi par e-mail dès l’expédition."],
  ["Et si elle ne me convient pas ?", "Vous disposez de 14 jours après la réception pour vous rétracter, sans avoir à vous justifier. Nous vous remboursons intégralement, livraison comprise. Les frais de retour sont à votre charge, sauf si le produit est défectueux, endommagé ou non conforme."],
  ["Quelle garantie ?", "Kiyohako One bénéficie de la garantie légale de conformité de 2 ans."],
  ["Puis-je payer en plusieurs fois ?", "Oui, en 3 fois sans frais avec Klarna dès 100 € d’achat, sous réserve d’acceptation par Klarna."],
  ["Comment vous contacter ?", "Notre service client vous répond du lundi au vendredi, de 9 h à 18 h, par e-mail ou par téléphone."]
];
